import { notNull } from '@gap/utils/utils'

export function capitalize(input: string) {
   if (!input.length) {
      return input
   }

   return input.charAt(0).toUpperCase() + (input.length > 1 ? input.slice(1) : '')
}

export function capitalizeAllWords(input: string) {
   if (!input.length) {
      return input
   }

   return input.split(' ').map(capitalize).join(' ')
}


/**
 * This function will count how many times char occurs in the input string
 * @param input input string
 * @param char char to count for
 * @returns number of chars found
 * @example
 * const count = countChar('1.2.3.4', '.')
 * // count = 3
 */
export function countChar(input: string, char: string): number {
   return notNull(input).split(notNull(char)).length - 1
}